import Enum from "@/utils/Enum";


// 游戏id
export const SNAIL_ID = new Enum()
  .setItem("jp", 51, "日本蜗牛游戏ID")
  .setItem("th", 57, "泰国蜗牛游戏ID")
  .setItem("en", 64, "欧美蜗牛游戏ID")
  .setItem("zh", 0, "港澳台蜗牛游戏ID"); // 港澳台未定

export const SERVICE_LINK = new Enum()
  .setItem(
    "jp",
    "https://law.qingcigame.com/th-th/service_agreement.html",
    "日本-服务协议链接"
  )
  .setItem(
    "th",
    "https://law.qingcigame.com/th-th/service_agreement.html",
    "泰国-服务协议链接"
  )
  .setItem(
    "en",
    "https://law.qingcigame.com/en-us/service_agreement.html",
    "欧美-服务协议链接"
  )
  .setItem(
    "zh",
    "https://law.qingcigame.com/th-th/service_agreement.html",
    "港澳台-服务协议链接"
  )
  .setItem(
    "sea_zh",
    "https://law.qingcigame.com/sea-zh/service_agreement.html",
    "东南亚中文-服务协议链接"
  )
  .setItem(
    "sea_id",
    "https://law.qingcigame.com/sea-id/service_agreement.html",
    "印度尼西亚-服务协议链接"
  )
  .setItem(
    "sea_en",
    "https://law.qingcigame.com/sea-en/service_agreement.html",
    "东南亚英文-服务协议链接"
  )
  .setItem(
    "sea_th",
    "https://law.qingcigame.com/th-th/service_agreement.html",
    "泰国-服务协议链接"
  )
  .setItem(
    "sea_vi",
    "https://law.qingcigame.com/vi-vn/service_agreement.html",
    "越南-服务协议链接"
  )

export const PRIVACY_LINK = new Enum()
  .setItem(
    "jp",
    "https://law.qingcigame.com/th-th/privacy_policy.html",
    "日本-隐私协议链接"
  )
  .setItem(
    "th",
    "https://law.qingcigame.com/th-th/privacy_policy.html",
    "泰国-隐私协议链接"
  )
  .setItem(
    "en",
    "https://law.qingcigame.com/en-us/privacy_policy.html",
    "欧美-隐私协议链接"
  )
  .setItem(
    "zh",
    "https://law.qingcigame.com/th-th/privacy_policy.html",
    "港澳台-隐私协议链接"
  )
  .setItem(
    "sea_zh",
    "https://law.qingcigame.com/sea-zh/privacy_policy.html",
    "东南亚中文-隐私协议链接"
  )
  .setItem(
    "sea_id",
    "https://law.qingcigame.com/sea-id/privacy_policy.html",
    "印度尼西亚-隐私协议链接"
  )
  .setItem(
    "sea_en",
    "https://law.qingcigame.com/sea-en/privacy_policy.html",
    "东南亚英文-隐私协议链接"
  )
  .setItem(
    "sea_th",
    "https://law.qingcigame.com/th-th/privacy_policy.html",
    "泰国-隐私协议链接"
  )
  .setItem(
    "sea_vi",
    "https://law.qingcigame.com/vi-vn/privacy_policy.html",
    "越南-隐私协议链接"
  )

// 阿里监控
export const GAME_ARMS_ID = new Enum()
  .setItem("jp_snail", "egrrccpv71@ab7838af34f75ee", "日本蜗牛的pid")
  .setItem("th_snail", "egrrccpv71@baccdb2489cc674", "泰国蜗牛的pid")
  .setItem("en_snail", "egrrccpv71@c4a3cd1c36a604a", "欧美蜗牛的pid")
  .setItem("zh_snail", "", "港澳台蜗牛的pid"); // 港澳台未定

// H5 活动登录/选服使用的游戏配置
export const APP_ID = {
  jp: 51,
  snail: 64,
  snail_tw: 64
};

export const GAME_AREA = {
  jp: [
    {
      id: 51,
      name: "Global"
    },
    {
      id: 51,
      name: "Global"
    }
  ],
  snail: [
    {
      id: 64,
      name: "Global"
    },
    {
      id: 64,
      name: "Global"
    }
  ],
  snail_tw: [
    {
      id: 64,
      name: "Global"
    },
    {
      id: 64,
      name: "Global"
    }
  ]
};



// WEBPACK FOOTER //
// ./src/config/constant.js